export default "__VITE_ASSET__Dwk_q2NS__"